import { setPaymentStatus, clearPaymentStatus } from './actions';
const initialState = null;
function paymentStatusReducer(state = initialState, { type, payload }) {
    switch (type) {
        case setPaymentStatus.toString():
            return payload;
        case clearPaymentStatus.toString():
            return initialState;
        default:
            return state;
    }
}
export default paymentStatusReducer;
